{
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Download (v2)"
      }
    }
  },
  "includedProducts": {
    "quotaLeft": {
      "singular": "Only one left",
      "plural": "Only {quota} left"
    }
  },
  "subHeader": {
    "backToMyBookings": "Exit trip",
    "backToMyBookingsAria": "Exit trip"
  }
}
